/*
  Shoppers outside the UK pay in their own currency. Product prices already
  come through converted, but amounts typed into the theme or its settings
  ("Save £70 - no code needed", "£10 voucher") are plain text in pounds.
  This turns those into the shopper's currency, at Shopify's own rate, written
  the same way as the prices around them.

  Whole pounds stay whole and are rounded down, so a saving is never shown as
  bigger than it is. Blog post text, Klarna's UK terms and the Merits page are left
  alone, and anything inside [data-magnum-pounds] is too.
*/
(function () {
  var config = window.magnumCurrency;
  if (!config || config.code === 'GBP') return;

  var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
  if (!rate || rate === 1) return;

  var POUNDS = /£\s?(\d{1,3}(?:,\d{3})+|\d+)(\.\d{1,2})?/g;
  var SKIP = 'script, style, noscript, textarea, input, select, .ma-content, .article-template__content, #magnum-drawer-klarna, [data-magnum-pounds]';

  function convert(text) {
    return text.replace(POUNDS, function (match, whole, pence) {
      var pounds = parseFloat(whole.replace(/,/g, '') + (pence || ''));
      var local = pounds * rate;
      if (!pence) return window.magnumMoney(Math.floor(local) * 100, true);
      return window.magnumMoney(Math.round(local * 100));
    });
  }

  function run(root) {
    if (config.skip) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.nodeValue.indexOf('£') === -1) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || parent.closest(SKIP)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      node.nodeValue = convert(node.nodeValue);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document.body);
    });
  } else {
    run(document.body);
  }
})();
